import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { GreenroomState } from '../../../stores/types/types';

interface DebugGateProps {
	children: JSX.Element,
	debugFeatureFlag: boolean
}
export const DebugGate = (props: DebugGateProps) => {
	const debugEnabled = useSelector((state: GreenroomState) => state.DebugReducer.debugEnabled);
	if (debugEnabled && !props.debugFeatureFlag) {
		return <></>;
	} else {
		return props.children;
	}
};